import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';

const EMPTY = { kind: 'login', name: '', description: '', url: '', login_url: '', username: '', password: '', enabled: true };

const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="text-sm font-medium text-foreground">{label}</span>
    {children}
    {hint && <span className="block text-xs text-muted-foreground mt-1">{hint}</span>}
  </label>
);

export const LoginConnectionForm = ({ initial, onSave, onCancel }) => {
  const [f, setF] = useState({ ...EMPTY, ...initial, password: '' });
  const [agree, setAgree] = useState(!!initial);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => { e.preventDefault(); setBusy(true); await onSave(f); setBusy(false); };

  return (
    <form onSubmit={submit} className="rounded-xl border border-primary/40 p-4 space-y-4" data-testid="login-connection-form">
      <Field label="1. Give it a name" hint="Anything you like, so you recognise it.">
        <Input value={f.name} onChange={set('name')} placeholder="My inventory" required data-testid="login-conn-name-input" />
      </Field>
      <Field label="2. What should your Pro check with it?" hint="In your own words. This tells your Pro when to use it.">
        <Textarea value={f.description} onChange={set('description')} rows={2} placeholder="If a product is in stock and how much it costs" required minLength={5} data-testid="login-conn-description-input" />
      </Field>
      <Field label="3. Link to the page that shows your inventory" hint="Log in on your own computer, open the page with your stock list, and copy the link from the top of your browser.">
        <Input value={f.url} onChange={set('url')} placeholder="https://..." required data-testid="login-conn-url-input" />
      </Field>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="4. Username or email you log in with">
          <Input value={f.username} onChange={set('username')} autoComplete="off" required data-testid="login-conn-username-input" />
        </Field>
        <Field label="5. Password" hint={initial?.password_set ? 'Already saved. Leave blank to keep it.' : 'Stored locked and encrypted. Only used to read your inventory.'}>
          <Input type="password" value={f.password} onChange={set('password')} autoComplete="new-password" required={!initial?.password_set} data-testid="login-conn-password-input" />
        </Field>
      </div>
      <Field label="Login page link (optional)" hint="Only if the login page is at a different link than your inventory page.">
        <Input value={f.login_url} onChange={set('login_url')} placeholder="https://.../login" data-testid="login-conn-loginurl-input" />
      </Field>
      <label className="flex items-start gap-2 text-xs text-muted-foreground">
        <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-0.5" data-testid="login-conn-agree-checkbox" />
        This is my business's account and I'm allowed to let Front Desk Pro sign in to read it.
      </label>
      <div className="flex gap-2">
        <Button type="submit" disabled={busy || !agree} data-testid="login-conn-save-btn">{busy ? 'Signing in to check...' : 'Connect'}</Button>
        <Button type="button" variant="ghost" onClick={onCancel} data-testid="login-conn-cancel-btn">Cancel</Button>
      </div>
      <p className="text-xs text-muted-foreground">We sign in once right now to make sure it works. Sites that send a text code or show an "I'm not a robot" check can't be connected this way. Use the API option instead.</p>
    </form>
  );
};
